<template>
    <div id="app" class="relative" >
    <!-- <div class="mask fixed-top w-100 h-100" style="background:transparent;"> -->
    <div class="mask fixed-top w-100 h-100" @click="handleCloseNav" style="background:transparent;" v-show="closeNav">
    </div>
        <navbar class="" @changeMenuClose="changeMenuClose" :closeNav="closeNav" />
        <transition name="el-fade-in">
            <keep-alive :include="cachedViews">
                <router-view v-if="$route.path" :key="key" />
            </keep-alive>
        </transition>
        <PublicFooter />
        <buyLink class="" />
    
        
    </div>
</template>

<script>
import navbar from "@/layout/navbar.vue"
export default {
    name: 'App',
    data() {
        return {
            closeNav: false,
            screenOneHeight:null,
        }
    },
    components: {
        navbar
    },
    computed: {
        cachedViews() {
            // return this.$store.state.tagsView.cachedViews
        },
        key() {
            return this.$route.path
        }
    },
    watch: {
        '$route'(n, o) {

        }
    },
    created() {
        this.setNewsList()
    },
    mounted() {
        let deviceWidth = window.innerWidth;
        if (deviceWidth < 500) {
            let container = document.querySelector("#app")
            container.style.paddingTop = "60px"
        } else {
            // this.screenOneHeight = window.innerHeight + "px";
            // this.closeNav=false
            
          
            // console.log(this.closeNav);
            
        }
    },
    updated() {
        // this.$nextTick(() => {
        //     document.querySelector(".container").addEventListener("click", (e) => {
        //         this.closeNavFun(false)
        //     })
        // })
    },
    methods: {
   
        changeMenuClose(data) {
            // console.log(data);
            
            // if (data === true) {
                this.closeNav = data
                // console.log(this.closeNav);
            // }

        },
        handleCloseNav(){
            this.closeNav=false
        },
        // closeNavFun(isClose) {
        //     let deviceWidth = window.innerWidth
        //     if (deviceWidth < 500) {
        //         if (this.closeNav === true) {
        //             this.$nextTick(() => {
        //                 this.closeNav = isClose
        //             })
        //         }
        //     }
        // },
        setNewsList() {
            this.$store.dispatch("getNewsList")
        },
        // getSwiperList() {
        //     let params = {
        //         pageNum: 1,
        //         pageSize: 10,
        //     }
        //     this.$store.dispatch("getSwiperList", params)
        // },
    },
}
</script>

<style lang="scss" scoped>
body {
    #app {
        margin: 0 !important;
        // padding: 60px 0 0 !important;
    }
}
</style>
